import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const SingaporePage = () => {
  return <DestinationTemplate destinationId="singapore" />;
};

export default SingaporePage;
